import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ handleLogout }) => {
  const username = "Admin";

  return (
    <div className="sidebar">
      <div>
        <h3 className="sidebar-title">Alsace Colis Express</h3>
        <p className="welcome-message">Bonjour, <strong>{username}</strong></p>
        <ul>
          <li>
            <NavLink to="/" end>Tableau de bord</NavLink>
          </li>
          <li>
            <NavLink to="/manage-drivers">Gestion des chauffeurs</NavLink>
          </li>
        </ul>
      </div>
      <div className="user-info">
        <button onClick={handleLogout} className="logout-btn">
          Se déconnecter
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
